import { render } from "./advantage.vue?vue&type=template&id=bc96c7b2"
import script from "./advantage.js?vue&type=script&lang=js"
export * from "./advantage.js?vue&type=script&lang=js"

import "./advantage.vue?vue&type=style&index=0&id=bc96c7b2&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__